module.exports = __webpack_public_path__ + "static/media/recurAzulO.0d8c5e35.png";